import React from 'react';
import { Content } from './shared';

const BcbsGarmin = () => (
  <Content>
    Keep tabs on your steps and overall activity level with Garmin devices.
    <ol>
      <li>Visit the Blue365 website and register.</li>

      <li>
        Go to Fitness {'>'} Garmin {'>'} Go to partner site.
      </li>

      <li>Discount will automatically be taken at checkout.</li>
    </ol>
    Note: Discount is available on Vivo, Forerunner, Fenix, Instinct, and Index Smart Scale models.
  </Content>
);

export default BcbsGarmin;
